<template>
    <nav id="menu">
      <div class="menu__items">
        <a class="home-btn" href="#" v-on:click="jumpToHome">Home</a>
        <a class="approach-btn" href="#" v-on:click="jumpToApproach">Approach</a>
        <a class="work-btn" href="#" v-on:click="jumpToWork">Our Work</a>
        <a class="contact-btn" href="#" v-on:click="jumpToContact">Contact</a>
      </div>
    </nav>
</template>

<script>

import * as $ from 'jquery'


export default {
  name: 'Menu',

  props: {
    bodyScrollBar: null
  },
  

  methods: {

      jumpToHome: function(){
        let bodyScroll      = this.bodyScrollBar;
        bodyScroll.scrollTo(0, 0, 600);
        this.closeMenu();
      },

      jumpToApproach: function(){
        let bodyScroll      = this.bodyScrollBar;
        bodyScroll.scrollIntoView(document.querySelector('#about'));
        this.closeMenu();
      },

      jumpToWork: function(){
        let bodyScroll      = this.bodyScrollBar;
        bodyScroll.scrollIntoView(document.querySelector('#work'));
        this.closeMenu();
      },

      jumpToContact: function(){
        let bodyScroll      = this.bodyScrollBar;
        bodyScroll.scrollIntoView(document.querySelector('#footer'));
        this.closeMenu();
      },

      closeMenu: function() {
        $('body').removeClass("menu--active");
        $('#menu-btn').find("span").text("Menu");
        $('#menu-btn').removeClass("is-active");
      }
  }
}
</script>

<style scoped>

</style>
